export default "__VITE_ASSET__f7355873__"